module.exports = __webpack_public_path__ + "static/img/2.e1c9bd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/ovulation/2.png
// module id = S3pi
// module chunks = 1